class ProductETA {
  constructor(variants, sku, ip) {
    this.variants=variants;
    this.sku=sku;
    this.available = ( ip === 'continue' );
    this.quantity=1;
    this.buttonTextStart = "Check ETA";
    this.buttonTextAvailable = "Current ETA: ";
    this.buttonTextUnknown = "We will fulfill the item as soon as it becomes available";
    this.predecessorSelector = "button[name='add']";      
    this.variantSelector = "form[action^='/cart/add']:first select:visible, .radio-wrapper fieldset, form[action^='/cart/add']:first input[type='radio'], variant-radios fieldset";
    this.quantitySelector = "input[name='quantity']";
    this.variantSelectors = $(document).find(this.variantSelector);
    this.quantityField = $(document).find(this.quantitySelector)[0];
    this.stockInStore = document.getElementById('cnc-container');
    this.getQuantity();
    this.addETAButton();
    this.addEventHandlers();
    this.displayETAButton();
    //this.predecessorMsgSelector = "div[class='gPreorderBottomMessage']"; 
    //document.getElementByClassName(this.predecessorMsgSelector).addEventListener("load", modifyETAmessage);
  }
  getQuantity() {
    (this.quantityField !== undefined) ? this.quantity = this.quantityField.value : this.quantity=1;
  }
  addETAButton() {
    var predecessor = document.querySelectorAll(this.predecessorSelector);
    
    this.etaButton = document.createElement('button');      
    this.etaButton.id='rex-eta';
    this.etaButton.type='button';
    this.etaButton.classList = predecessor[1].classList;
    this.etaButton.classList.replace("button--add-to-cart", "button--link");
    this.etaButton.classList.remove("gPreorderBtn");
    this.etaButton.style.marginTop = '10px';
    predecessor[1].after(this.etaButton); 
    
    this.etaButtonText = document.createElement('span');
    this.etaButtonText.textContent = this.buttonTextStart;
    this.etaButton.appendChild(this.etaButtonText);
    
    this.etaSpinner = document.createElement('div');    
    this.etaSpinner.id='spinner';
    this.etaSpinner1 = document.createElement('div'); 
    this.etaSpinner1.classList.add('bounce1');
    this.etaSpinner.appendChild(this.etaSpinner1);
    this.etaSpinner2 = document.createElement('div'); 
    this.etaSpinner2.classList.add('bounce2');
    this.etaSpinner.appendChild(this.etaSpinner2);
    this.etaSpinner3 = document.createElement('div'); 
    this.etaSpinner3.classList.add('bounce3');
    this.etaSpinner.appendChild(this.etaSpinner3);
    this.etaButton.after(this.etaSpinner);
  }
  // modifyETAmessage() {
  //  var etamsg = document.getElementsByClassName(this.predecessorMsgSelector);
  //  this.etamsg[0].textContent = this.buttonTextStart;
  //}
  addEventHandlers() {    
    this.etaButton.addEventListener('click', (event) => {
      this.getProductETA();
    });
    
    for (let i=0; i < this.variantSelectors.length; i++) {      
      this.variantSelectors[i].addEventListener('change', (event) => {
        setTimeout(() => {
          this.currentVariant = this.variants.find(variant => variant.id == this.findGetParameter('variant'));
          this.sku = this.currentVariant.sku;
          this.available = ( this.currentVariant.inventory_policy === 'continue' );
    	  this.displayETAButton();
        }, 250);
      });
    }
    if ( this.quantityField !== undefined ) {
      this.quantityField.addEventListener('input', (event) => {
        this.getQuantity();
        this.displayETAButton();
        
      });
      this.quantityField.addEventListener('change', (event) => {
        this.getQuantity();
        this.displayETAButton();
      });
    }
  }
  displayETAButton() {
    if ( this.available ) {
      this.etaButtonText.textContent = this.buttonTextStart;
      this.etaButton.style.display = 'block';
      if ( this.stockInStore !== undefined ) {
      	this.stockInStore.style.display = 'none';
      }
    } else {
      this.etaButton.style.display = 'none';
      if ( this.stockInStore !== undefined ) {
        this.stockInStore.style.display = 'block';
      }
    }
  }
  getProductETA(){
    var parent = this;
    
    parent.etaButton.style.display = 'none';
    parent.etaSpinner.style.display = 'block';   

    var url = `/apps/retailexpress/products/eta?sku=${this.sku}&quantity_ordered=${this.quantity}&available_for_preorder=true`;
    
    var etaRequest = new Request(url);

    fetch(etaRequest).then(response => response.json()).then(data => {
      
      parent.etaButton.style.display = 'block';
      parent.etaSpinner.style.display = 'none';
      
      if (data.data.length > 0 ) {
        var eta = new Date(data.data[0].eta);

        if (  eta < new Date() ) {
          parent.etaButtonText.textContent = parent.buttonTextUnknown;
        } else {        
          parent.etaButtonText.textContent = parent.buttonTextAvailable + new Intl.DateTimeFormat('en-AU').format(eta);
        }
      } else {
        parent.etaButtonText.textContent = parent.buttonTextUnknown;
      }
    });
  }
  findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
  }
}